import { findIndex, cloneDeep } from "lodash"
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  active: false,
  temp: 25,
  timer: 0,
  timeIncrement: 15,
  tempIncrement: 1,
  increment: 1,
  minTime: 0,
  maxTime: 6000,
  minTemp: 25,
  maxTemp: 220,
  numberOfSolutions: 0,
  solutions: [{
    id: null,
    type: null
  },{
    id: null,
    type: null
  },{
    id: null,
    type: null
  },{
    id: null,
    type: null
  },{
    id: null,
    type: null
  },{
    id: null,
    type: null
  }]
};

export function HeatBlockReducer(state = { heatBlocks: [] }, action) {
  let currentHeatBlock;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_HEAT_BLOCK" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
        if(state.protocolSection.scene.apparatus.hasOwnProperty("heatBlocks")){
          currentHeatBlock = state.protocolSection.scene.apparatus.heatBlocks[findIndex(state.protocolSection.scene.apparatus.heatBlocks, { id: action.payload.id })]
        }
      }
  }

  switch (action.type) {

        case 'CREATE_HEAT_BLOCK':

          //Create new obj from template state
          let newObj = { ...templateState, ...action.payload.props }

          if(protocolSection.scene.apparatus.hasOwnProperty("heatBlocks")){
            protocolSection.scene.apparatus.heatBlocks = [ ...protocolSection.scene.apparatus.heatBlocks, newObj ]
          } else {
            protocolSection.scene.apparatus.heatBlocks = [newObj]
          }

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        // case 'SET_HEAT_BLOCK':
        //     //Payload = [id, solution]
        //     currentHeatBlock.type = action.payload.type
        //     protocolSection.scene.apparatus.heatBlocks[findIndex(protocolSection.scene.apparatus.heatBlocks, { id: action.payload.id })] = currentHeatBlock
        //
        //     return { ...state, ...{
        //       protocolSection: protocolSection
        //     } }

        case "SET_HEAT_BLOCK_ACTIVE":
          //Payload = {active}
          currentHeatBlock.active = action.payload.active
          protocolSection.scene.apparatus.heatBlocks[findIndex(protocolSection.scene.apparatus.heatBlocks, { id: action.payload.id })] = currentHeatBlock

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case "INC_HEAT_BLOCK_TIME":
          //Payload = {active}
          let inctime = currentHeatBlock.timer

          if ((inctime + currentHeatBlock.timeIncrement) <= currentHeatBlock.maxTime) {
              inctime += currentHeatBlock.timeIncrement

              currentHeatBlock.timer = inctime
              protocolSection.scene.apparatus.heatBlocks[findIndex(protocolSection.scene.apparatus.heatBlocks, { id: action.payload.id })] = currentHeatBlock

              return { ...state, ...{
                protocolSection: protocolSection
              } }

          } else {
              return state
          }



        case "DEC_HEAT_BLOCK_TIME":
          //Payload = {active}
          let dectime = currentHeatBlock.timer

          if ((dectime - state.timeIncrement) >= state.minTime) {
              dectime -= state.timeIncrement

              currentHeatBlock.timer = dectime
              protocolSection.scene.apparatus.heatBlocks[findIndex(protocolSection.scene.apparatus.heatBlocks, { id: action.payload.id })] = currentHeatBlock

              return { ...state, ...{
                protocolSection: protocolSection
              } }

          } else {
              return state
          }

        case "COUNT_DOWN_HEAT_BLOCK_TIME":
          //Payload = {active}
          let countDownTime = currentHeatBlock.timer

          if ((countDownTime - action.payload.interval) >= state.minTime) {
              countDownTime -= action.payload.interval

              currentHeatBlock.timer = countDownTime
              protocolSection.scene.apparatus.heatBlocks[findIndex(protocolSection.scene.apparatus.heatBlocks, { id: action.payload.id })] = currentHeatBlock

              return { ...state, ...{
                protocolSection: protocolSection
              } }

          } else {
              return state
          }

        case "INC_HEAT_BLOCK_TEMP":
          //Increases current for by currentIncrement
          let inctemp = currentHeatBlock.temp

          if ((inctemp + state.tempIncrement) <= state.maxTemp) {

              inctemp += state.tempIncrement

              currentHeatBlock.temp = inctemp
              protocolSection.scene.apparatus.heatBlocks[findIndex(protocolSection.scene.apparatus.heatBlocks, { id: action.payload.id })] = currentHeatBlock

              return { ...state, ...{
                protocolSection: protocolSection
              } }

          } else {
              return state
          }

        case "DEC_HEAT_BLOCK_TEMP":
          //Increases current for by currentIncrement
          let dectemp = currentHeatBlock.temp

          if ((dectemp - state.tempIncrement) >= state.minTemp) {

              dectemp -= state.tempIncrement

              currentHeatBlock.temp = dectemp
              protocolSection.scene.apparatus.heatBlocks[findIndex(protocolSection.scene.apparatus.heatBlocks, { id: action.payload.id })] = currentHeatBlock

              return { ...state, ...{
                protocolSection: protocolSection
              } }

          } else {
              return state
          }

        case "RESET_HEAT_BLOCK_TIME":
          //Payload = {voltage}
          currentHeatBlock.timer = 0;
          protocolSection.scene.apparatus.heatBlocks[findIndex(protocolSection.scene.apparatus.heatBlocks, { id: action.payload.id })] = currentHeatBlock

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case "ADD_TUBE_TO_HEAT_BLOCK":
          //Payload = {id, type}
          let addSolutions = cloneDeep(currentHeatBlock.solutions);
          let availableSlot = -1;

          for(var i = 0; i < currentHeatBlock.solutions.length; i++){
            if(currentHeatBlock.solutions[i].type == null){
              availableSlot = i;
              break;
            }
          }

          if(availableSlot !== -1){
            addSolutions[availableSlot].type = action.payload.type;
            addSolutions[availableSlot].id = action.payload.solutionId;
            currentHeatBlock.numberOfSolutions++
          }

          currentHeatBlock.solutions = addSolutions;
          protocolSection.scene.apparatus.heatBlocks[findIndex(protocolSection.scene.apparatus.heatBlocks, { id: action.payload.id })] = currentHeatBlock

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case "REMOVE_TUBE_FROM_HEAT_BLOCK":
          //Payload = {id, type}
          let removeSolutions = cloneDeep(currentHeatBlock.solutions);

          if(action.payload.index !== null && removeSolutions.hasOwnProperty(action.payload.index) && removeSolutions[action.payload.index].type !== null){
            removeSolutions[action.payload.index].type = null;
            removeSolutions[action.payload.index].id = null;
            currentHeatBlock.numberOfSolutions++
          }

          currentHeatBlock.solutions = removeSolutions;
          protocolSection.scene.apparatus.heatBlocks[findIndex(protocolSection.scene.apparatus.heatBlocks, { id: action.payload.id })] = currentHeatBlock

          return { ...state, ...{
            protocolSection: protocolSection
          } }

          // case "UNDO":
          //     //Payload = {lastState}
          //
          //     if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('heatBlocks')) {
          //
          //       protocolSection.scene.apparatus.heatBlocks = action.payload.lastState.scene.apparatus.heatBlocks
          //
          //       return { ...state, ...{
          //         protocolSection: protocolSection
          //       } }
          //
          //     } else {
          //       return state;
          //     }

        default:
            return state;
    }
}
